import { DOWNLOAD_PATH, getStoreUrl } from "#website-store-links";
import { useWebsiteStorePlatform } from "#use-website-store-platform";

/**
 * Where a "get the app" action goes: the visitor's store on a phone, `downloadHref` otherwise. The
 * landing passes its own download section's fragment; other pages use the `/download` redirect.
 */
export function useWebsiteGetAppHref(downloadHref: string = DOWNLOAD_PATH): string {
  const platform = useWebsiteStorePlatform();
  return platform === null ? downloadHref : getStoreUrl(platform);
}
